export default function CustomRing(){
    return (
        <div className="absolute hidden group-hover:block w-full h-full border-[4px] rounded-xl border-secondary top-0 left-0.3"></div>
    )
}